import { WidthFullTwoTone } from "@mui/icons-material";
import {
  Paper,
  useTheme,
  Box,
  Typography,
  Stack,
  IconButton,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { ReactComponent as TitleBarSVG } from "../../../assets/easyMaps/titlebar.svg";
import { useState, useRef, useEffect } from "react";
import * as React from "react";
import api from "../../../services/api";
import AlertModal from "../../../componentes/alertModal";
import { useNavigate } from "react-router-dom";
import ConfiguracaoMapModal from "../configMapModal";
import CsvPreviewModal from "./modals/CsvPreviewModal";
import JsonPreviewModal from "./modals/JsonPreviewModal";
import {
  csvIntoJson,
  jsonToCSV,
} from "../../../utils/easyMaps/csvAndJsonConverter";

const TitleBar = ({
  title,
  id,
  setSnackbar,
  center,
  exportImport,
  produtos = [],
  onImportComplete,
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [positionCenter, setPositionCenter] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [titleMap, setTitleMap] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openConfigModal, setOpenConfigModal] = useState(false);
  const [hostsData, setHostsData] = useState([]);
  const [up, setUp] = useState(false);
  const [previewCsvModal, setPreviewCsvModal] = useState(false);
  const [elementData, setElementData] = useState([]);
  const [duplicatedRows, setDuplicatedRows] = useState([]);
  const [exportAnchor, setExportAnchor] = useState(null);
  const [importAnchor, setImportAnchor] = useState(null);
  const [jsonPreviewData, setJsonPreviewData] = useState(null);
  const [previewJsonModal, setPreviewJsonModal] = useState(false);
  const [userPermission, setUserPermission] = useState("");

  const inputRef = useRef();
  const fileInputRef = useRef(null);
  const fileJsonInputRef = useRef(null);
  const barRef = useRef(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const titleMapRef = useRef();
  const upRef = useRef();

  useEffect(() => {
    titleMapRef.current = titleMap;
    upRef.current = up;
  }, [titleMap, up]);

  useEffect(() => {
    setTitleMap(title);
  }, [title]);

  useEffect(() => {
    if (editMode) inputRef.current.focus();
  }, [editMode]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleEdit = () => {
    setAnchorEl(null);
    setEditMode(true);
  };
  const handleConfig = () => {
    setAnchorEl(null);
    setOpenConfigModal(true);
  };
  const DeleteModal = (props) => <AlertModal {...props} />;
  function update() {
    let position = window.innerWidth - 690;
    setPositionCenter(position / 2 - 160);
  }
  useEffect(() => {
    update();
  }, [center]);

  useEffect(() => {
    window.addEventListener("resize", update);
    const role =
      JSON.parse(localStorage.getItem("1"))?.usuarioCliente?.codigoPermissao ||
      "";
    setUserPermission(role);
    return () => {
      window.removeEventListener("resize", update);
    };
  }, []);

  useEffect(() => {
    if (produtos) {
      console.log(produtos);
      getHosts(produtos[0]?.AcessoLink[0]?.link);
    }
  }, []);

  async function getHosts(link) {
    try {
      const response = await api.post("/easyMaps/zabbix/hosts", {
        link: link,
      });
      setHostsData(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  function findAndFormatHostByName(name) {
    const host = hostsData.find((h) => h.host === name);
    if (!host) return null;
    return {
      host: host.host,
      hostid: host.hostid,
      hostname: host.host,
      interfaces: host.interfaces || [],
      itens: [],
      tags: host.tags || [],
    };
  }

  const styles = {
    icon: {
      color: theme.palette.color.icons,
    },
    button: {
      borderRadius: "5px",
      padding: "5px",
    },

    box: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "360px",
      position: "absolute",
      left: 0,
      right: 0,
      top: { xs: 50, sm: 0 },
      background: "none",
      marginLeft: "auto",
      marginRight: "auto",
      zIndex: 1,
    },
    modal: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 800,
      bgcolor: "background.default",
      boxShadow: 24,
      p: 4,
    },
    text: {
      maxWidth: "230px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    stack: {
      mt: "-60px",
      justifyContent: "center",
      alignItems: "center",
      gap: 1,
    },
  };

  async function handleApiDeleteMap() {
    setOpenDeleteModal(false);

    try {
      const response = await api.post("/easyMaps/map/delete", {
        mapId: id,
        logsLoginClienteId: JSON.parse(localStorage.getItem("logs"))?.id || "",
      });

      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível deletar o mapa",
          severity: "error",
        });
        setTitleMap(title);
      } else {
        navigate("/easyMaps");
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Error: Não foi possível se conectar com o servidor",
        severity: "error",
      });
    } finally {
      setUp(false);
    }
  }

  async function updateTitleMap() {
    if (!upRef.current) return;

    try {
      const response = await api.put("/easyMaps/map/updateTitle", {
        mapId: id,
        titulo: titleMapRef.current,
        logsLoginClienteId: JSON.parse(localStorage.getItem("logs"))?.id || "",
      });

      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível atualizar o titulo",
          severity: "error",
        });
        setTitleMap(title);
      } else {
        setTitleMap(response.data.titulo);
        setSnackbar({
          children: "Título Atualizado com Sucesso",
          severity: "success",
        });
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Error: Não foi possível se conectar com o servidor",
        severity: "error",
      });
    } finally {
      setUp(false);
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (barRef.current && !barRef.current.contains(event.target)) {
        setEditMode(false);
        updateTitleMap();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function downloadCSV(csv, filename = "export.csv") {
    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  function downloadJSON(jsonData, filename = "export.json") {
    const jsonString = JSON.stringify(jsonData, null, 2);
    const blob = new Blob([jsonString], { type: "application/json" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  async function handleExport() {
    try {
      const response = await api.post("/easyMaps/map/export", {
        mapId: id,
      });
      const formatedData = response.data.Element.map((element) => ({
        titulo: element.titulo,
        img: element.img,
        hostname: element.elementConfig.config.hosts[0].host,
        lat: element.elementConfig.config.coordenadas.lat,
        long: element.elementConfig.config.coordenadas.long,
      }));
      const csv = jsonToCSV(formatedData);
      downloadCSV(csv, `${titleMap}-EasyMaps.csv`);
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possível se conectar com o servidor",
        severity: "error",
      });
    }
  }
  async function handleExportJson() {
    try {
      const response = await api.post("/easyMaps/map/export", {
        mapId: id,
      });
      downloadJSON(response.data.Element, `${titleMap}-EasyMaps.json`);
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possível se conectar com o servidor",
        severity: "error",
      });
    }
  }

  async function handleImportJson(e) {
    if (!e.target.files[0]) {
      setSnackbar({
        children: "Error: Não foi possível ler o arquivo",
        severity: "error",
      });
      return;
    }
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = async function (event) {
      try {
        const jsonData = JSON.parse(event.target.result);
        if (!jsonData || !jsonData.length > 0) {
          throw new Error("Error: O arquivo Json está vazio");
        }
        setJsonPreviewData(jsonData);
        setPreviewJsonModal(true);
      } catch (error) {
        setSnackbar({
          children:
            error?.message ||
            error?.response?.data?.error ||
            "Error: Não foi possível importar os elementos",
          severity: "error",
        });
      }
    };
    reader.onerror = function () {
      setSnackbar({
        children: "Error: Não foi possível ler o arquivo JSON",
        severity: "error",
      });
    };
    reader.readAsText(file);
  }

  async function importJsonFromPreview() {
    if (!jsonPreviewData) return;
    let logs = JSON.parse(localStorage.getItem("logs"));
    try {
      await api.post("/easyMaps/element/createManyJson", {
        elementsData: jsonPreviewData,
        mapId: id,
        usuarioClienteId: logs.usuarioClienteId,
        logsLoginClienteId: logs.id,
      });
      setSnackbar({
        children: "Elementos importados com sucesso!",
        severity: "success",
      });
      setAnchorEl(null);
      onImportComplete();
    } catch (error) {
      setPreviewJsonModal(false);
      setJsonPreviewData(null);
      setSnackbar({
        children:
          error?.response?.data?.error ||
          "Error: Não foi possível importar os elementos",
        severity: "error",
      });
    }
  }

  async function importElements(elements) {
    let logs = JSON.parse(localStorage.getItem("logs"));
    const importedHosts = elements.map((point) => {
      const host = findAndFormatHostByName(point.hostname);
      if (!host) return null;

      return {
        titulo: point.titulo,
        tipo: 0,
        img: point.img,
        mapRefId: null,
        mapId: id,
        configuracao: {
          coordenadas: {
            lat: point.lat,
            long: point.long,
          },
          hosts: [host],
          produtoId: produtos[0]?.id,
        },
      };
    });
    try {
      await api.post("/easyMaps/element/createMany", {
        elementsData: importedHosts,
        usuarioClienteId: logs.usuarioClienteId,
        logsLoginClienteId: logs.id,
      });
      setSnackbar({
        children: "Elementos importados com sucesso!",
        severity: "success",
      });
      setAnchorEl(null);
      onImportComplete();
    } catch (error) {
      setPreviewCsvModal(false);
      setSnackbar({
        children:
          error?.response?.data?.error ||
          "Error: Não foi possível importar os elementos",
        severity: "error",
      });
    }
  }

  async function handleImportCsv(e) {
    if (!e.target.files[0]) {
      setSnackbar({
        children: "Error: Não foi possível ler o arquivo",
        severity: "error",
      });
      return;
    }
    try {
      const result = await csvIntoJson(e.target.files[0]);
      if (!result.length > 0) {
        throw new Error("Error: O arquivo CSV está vazio");
      }
      setPreviewCsvModal(true);
      setElementData(result);
      setDuplicatedRows(getDuplicatedLatLongRows(result));
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: error.message || "Error: Falha ao importar o arquivo CSV",
        severity: "error",
      });
    }
  }

  function getDuplicatedLatLongRows(data) {
    const used = {};
    const duplicates = new Set();
    data.forEach((row, index) => {
      const key = `${row.lat},${row.long}`;
      if (used[key] !== undefined) {
        duplicates.add(index);
        duplicates.add(used[key]);
      } else {
        used[key] = index;
      }
    });
    return duplicates;
  }

  return (
    <>
      <Box sx={styles.box} ref={barRef}>
        <Stack direction="row" sx={styles.stack}>
          <CsvPreviewModal
            open={previewCsvModal}
            onClose={() => setPreviewCsvModal(false)}
            elementData={elementData}
            duplicatedRows={duplicatedRows}
            importElements={importElements}
          />
          <JsonPreviewModal
            open={previewJsonModal}
            onClose={() => {
              setPreviewJsonModal(false);
              setJsonPreviewData(null);
            }}
            jsonData={jsonPreviewData}
            importJson={async () => {
              await importJsonFromPreview();
            }}
            modalStyle={styles.modal}
            title="Preview JSON"
          />
          {!editMode && (
            <>
              <Typography sx={styles.text}>{titleMap}</Typography>
              <IconButton
                onClick={handleClick}
                size="small"
                sx={{
                  width: "20px",
                  height: "20px",
                }}
              >
                <KeyboardArrowDownIcon sx={{ fontSize: "18px" }} />
              </IconButton>
            </>
          )}
          {editMode && (
            <TextField
              variant="standard"
              inputRef={inputRef}
              InputProps={{
                disableUnderline: true,
                sx: {
                  mt: "-2px",
                  width: 10 + titleMap?.length * 8 + "px",
                  maxWidth: "200px",
                },
              }}
              value={titleMap}
              onChange={(event) => {
                setUp(true);
                setTitleMap(event.target.value);
              }}
            />
          )}
          <input
            ref={fileInputRef}
            hidden
            type="file"
            accept=".xls, .xlsx, .csv"
            onChange={(e) => {
              handleImportCsv(e);
              e.target.value = "";
            }}
          />
          <input
            ref={fileJsonInputRef}
            hidden
            type="file"
            accept=".json"
            onChange={(e) => {
              handleImportJson(e);
              e.target.value = "";
            }}
          />
        </Stack>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          sx={{
            "& .MuiPopover-paper": {
              backgroundColor: theme.palette.background.default,
            },
          }}
        >
          {" "}
          {exportImport && [
            <MenuItem
              key="export"
              onClick={(e) => setExportAnchor(e.currentTarget)}
            >
              Exportar
            </MenuItem>,
            <Menu
              key="export-menu"
              anchorEl={exportAnchor}
              open={Boolean(exportAnchor)}
              onClose={() => setExportAnchor(null)}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
              <MenuItem
                onClick={() => {
                  setExportAnchor(null);
                  setAnchorEl(null);
                  handleExport();
                }}
              >
                Baixar como CSV
              </MenuItem>
              {userPermission === "adm001" && (
                <MenuItem
                  onClick={() => {
                    setExportAnchor(null);
                    setAnchorEl(null);
                    handleExportJson();
                  }}
                >
                  Baixar como JSON
                </MenuItem>
              )}
            </Menu>,
            <MenuItem
              key="import"
              onClick={(e) => setImportAnchor(e.currentTarget)}
            >
              Importar
            </MenuItem>,
            <Menu
              key="import-menu"
              anchorEl={importAnchor}
              open={Boolean(importAnchor)}
              onClose={() => setImportAnchor(null)}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
              <MenuItem
                onClick={() => {
                  setImportAnchor(null);
                  fileInputRef.current && fileInputRef.current.click();
                }}
              >
                Importar como CSV
              </MenuItem>
              {userPermission === "adm001" && (
                <MenuItem
                  onClick={() => {
                    setImportAnchor(null);
                    fileJsonInputRef.current &&
                      fileJsonInputRef.current.click();
                  }}
                >
                  importar como JSON
                </MenuItem>
              )}
            </Menu>,
          ]}
          <MenuItem onClick={handleConfig}>Configurações</MenuItem>
          <MenuItem onClick={handleEdit}>Renomear</MenuItem>
          <MenuItem
            onClick={() => {
              setOpenDeleteModal(true);
            }}
          >
            Deletar
          </MenuItem>
        </Menu>
      </Box>
      <DeleteModal
        openModal={openDeleteModal}
        setOpenModal={setOpenDeleteModal}
        handleButton={handleApiDeleteMap}
        severity={"error"}
        singleButton={false}
      />
      <ConfiguracaoMapModal
        open={openConfigModal}
        setOpen={setOpenConfigModal}
      />
    </>
  );
};

export default TitleBar;
